import React from 'react';
import { t } from 'i18next';
import { Col, Row } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { EditableFormShell, FormMode } from '@app/Components/Forms/EditableFormShell';
import { TextField } from '@app/Components/Forms/Fields/TextField';
import type { UserSourceCreateDTO } from '@api/DTO/User/UserSource/dto';
import type { UserSourceValues } from './UserSourceCreateForm.form';
import { userSourceForm } from './UserSourceCreateForm.form';

type UserSourceCreateFormProps = {
  initialValues?: Partial<UserSourceValues>;

  isSaving?: boolean;

  onSubmit: (payload: UserSourceCreateDTO) => Promise<void>;
};

export const UserSourceCreateForm = ({
  initialValues,
  isSaving = false,
  onSubmit,
}: UserSourceCreateFormProps) => {
  const values = React.useMemo(() => userSourceForm.defaults(initialValues), [initialValues]);

  const form = useForm<UserSourceValues>({
    resolver: zodResolver(userSourceForm.schema),
    defaultValues: values,
    mode: 'onBlur',
  });

  const canEdit = true;

  return (
    <EditableFormShell<UserSourceValues>
      mode={'edit'}
      form={form}
      initialValues={values}
      canEdit={canEdit}
      isSaving={isSaving}
      submitLabel={t('common.continue')}
      onSubmit={async (values) => {
        const parsed = userSourceForm.schema.parse(values);

        await onSubmit(userSourceForm.mapper(parsed));
      }}
    >
      {() => (
        <Row>
          <Col>
            <TextField name="sourceName" label={t('userSource.createForm.sourceNameLabel')} />
          </Col>
        </Row>
      )}
    </EditableFormShell>
  );
};
